<script lang="ts">
  import {
    type Middleware,
    type Placement,
    type Strategy,
    flip,
    offset,
    shift,
  } from '@floating-ui/dom'
  import { Popover } from 'mono-svelte'
  import type { Snippet } from 'svelte'
  import type { Attachment } from 'svelte/attachments'

  interface Props {
    openOnHover?: boolean
    open?: boolean
    placement?: Placement
    middleware?: Middleware[]
    strategy?: Strategy
    class?: string
    target?: Snippet<[Attachment]>
    children?: import('svelte').Snippet<[boolean]>
  }

  let {
    openOnHover = false,
    open = $bindable(false),
    placement = 'bottom-start',
    middleware = [offset(6), shift({ padding: 6 }), flip()],
    strategy = 'absolute',
    target,
    children,
    ...rest
  }: Props = $props()
</script>

<Popover
  {openOnHover}
  {placement}
  {middleware}
  {strategy}
  {target}
  {...rest}
  bind:open
  popoverClass="rounded-xl w-full backdrop-blur-xl max-w-72"
>
  {#snippet popover()}
    <div
      class="w-full max-w-sm max-h-128 overflow-auto list-none shadow-lg rounded-xl select-none"
    >
      <div
        class="flex flex-col p-1 list-none bg-white/60 dark:bg-zinc-900/60 rounded-xl
        border border-slate-200 dark:border-zinc-800 dark:border-t-zinc-700 not-dark:border-b-slate-300 gap-px"
        role="menu"
      >
        {@render children?.(open)}
      </div>
    </div>
  {/snippet}
</Popover>
